/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

export const skipLinkStyle = {
  skipLink: {
    position: "absolute",
    top: "-40px",
    left: 0,
    zIndex: 1300,
    "&:focus-visible": {
      top: 0,
    },
  },
};
